import React from 'react'

import EnderecoFormPageContainer from './EnderecoFormPageContainer'

export class EnderecoFormPage extends React.Component {
  render() {
    return <EnderecoFormPageContainer {...this.props} />
  }
}
